import { NavLink, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useRouter } from "../../hooks/router";

import './NavBar.scss'
import './NavBarMedia.scss'

import ImgAuthor from '../Util/img'
import Modal from "../Pages/Modal/Modal";

import default_user_img from '../SubUsers/images/user_default.png'
import icon_home from './images/home (1).png'
import icon_home_active from './images/home_orange.png'
import icon_search from './images/search (1).png'
import icon_search_active from './images/search_orange.png'
import icon_tv_shows from './images/television (1).png'
import icon_tv_shows_active from './images/television_orange.png'
import icon_movies from './images/clapperboard (1).png'
import icon_movies_active from './images/clapperboard_orange.png'
import icon_channels from './images/tv (1).png'
import icon_channels_active from './images/tv_orange.png'
import icon_favourites from './images/heart.png'
import icon_favourites_active from './images/heart_orange.png'
import icon_settings from './images/settings.png'
import icon_log_out from './images/logout.png'
import icon_subusers from './images/profile.png'
import { get_language, translated_words } from "../../server/requests";
import { translateWord, decrypt } from "../Util/util";


export default function NavBar({ NavClass, type, configs, appSettings, notReadMessagesCount, isGuest }) {

    const router = useRouter()
    const user = JSON.parse(decrypt('user', localStorage.getItem('user')))

    const [listNavBar, setListNavBar] = useState([
        { id: 0, name: 'Home', menu_code: "home", to: '/', img: icon_home, active_img: icon_home_active, active: true },
        { id: 1, name: 'Search', menu_code: "search", to: '/search', img: icon_search, active_img: icon_search_active, active: false },
        { id: 2, name: 'Live TVs', menu_code: "live_tv", to: '/channels', img: icon_channels, active_img: icon_channels_active, active: false },
        { id: 3, name: 'Movies', menu_code: "movies", to: '/movies', img: icon_movies, active_img: icon_movies_active, active: false },
        { id: 4, name: 'TV Shows', menu_code: "tv_show", to: '/tv-shows', img: icon_tv_shows, active_img: icon_tv_shows_active, active: false },
        {
            id: 6,
            name: 'Favourites',
            menu_code: "favourites",
            to: '/favourites',
            img: icon_favourites,
            active_img: icon_favourites_active,
            active: false
        },
    ])
    const [showDropDown, setShowDropDown] = useState(false)
    const [logOut, setLogOut] = useState(false)
    const [languages, setLanguages] = useState([])
    const [activeLanguage, setActiveLanguage] = useState('')
    const [showLangList, setShowLangList] = useState(false)
    const [logo, setLogo] = useState('')
    const [hideMenu, setHideMenu] = useState(false)

    useEffect(() => {

        get_language({}, res => {
            if (!localStorage.getItem('language')) {
                const defaultLang = res.find(e => e.default == true)
                setActiveLanguage(defaultLang)
            } else {
                setActiveLanguage(JSON.parse(localStorage.getItem('language')))
            }
            setLanguages(res)
        })

        setLogo(localStorage.getItem('logo'))

        if (appSettings && appSettings.lessons) {

            let new_array = [...listNavBar]
            let obj = { id: 13, name: 'Lessons', menu_code: "lessons", to: '/lessons', img: icon_channels, active_img: icon_channels_active, active: false }

            new_array.splice(2, 1, obj)

            setListNavBar([...new_array])

        }

    }, []);
    useEffect(() => {
        if (window.innerWidth < 1000)
            setHideMenu(true)
        window.addEventListener('resize', () => {
            if (window.innerWidth < 1000)
                setHideMenu(true)
            else
                setHideMenu(false)
        })
    }, [])
    useEffect(() => {

        const onclick = () => {

            setTimeout(() => {
                setShowLangList(false);
            }, 100);

        }

        if (showLangList) {
            document.body.addEventListener("click", onclick);
        }

        return () => {
            document.body.removeEventListener("click", onclick);
        }

    }, [showLangList])

    const selectLanguage = (e) => {
        localStorage.setItem('language', JSON.stringify(e))
        setShowLangList(false)
        setActiveLanguage(e)
        window.location.reload()
    }

    const btn_nav_list = (e) => {
        let newList = listNavBar
        let x = newList.find(k => k.active === true)
        x.active = false
        e.active = true

        setListNavBar(newList)
    }



    const btn_drop_down_list = (i) => {

        if (i === 0) router.push('/subusers')

        else if (i === 1) router.push('/settings')

        else if (i === 2) setLogOut(true)

        setShowDropDown(false)

    }

    const btnConfirmLogOut = () => {

        let active_lang = JSON.parse(localStorage.getItem('language'))
        let background = localStorage.getItem('background_image')
        let logo = localStorage.getItem('logo')
        let device_id = localStorage.getItem('device_id')

        localStorage.clear()

        localStorage.setItem('language', JSON.stringify(active_lang))
        localStorage.setItem('background_image', background)
        localStorage.setItem('logo', logo)
        localStorage.setItem('device_id', device_id)

        setLogOut(false)

        if (configs && configs.logout_url) {
            let _redirected_url = configs.logout_url.replace('{{lang}}', (active_lang && active_lang.iso_code ? active_lang.iso_code : ''))
            window.location.href = _redirected_url
        } else {
            router.push('/auth')
        }

    }
    const btnCancelLogOut = () => setLogOut(false)

    return (
        <>
            {logOut ?
                <Modal
                    btnConfirm={btnConfirmLogOut}
                    btnCancel={btnCancelLogOut}
                    btnConfirmText={'Yes'}
                    btnCancelText={'No'}
                    title={'Are you sure that you want to sign out?'}
                />
                : null}

            <nav className={NavClass}>
                <div className="container_navbar">
                    <Link to={'/'} className={'logo_navbar ' + type}>
                        <img src={logo || configs.start_logo} alt="" />
                    </Link>


                    {
                        type != 'live' ?
                            <div className="navbar_list">
                                {
                                    hideMenu ?
                                        null
                                        :
                                        <>
                                            {listNavBar.map(e => {
                                                return (
                                                    <Link className={'nav_item ' + e.menu_code + ' ' + (router.pathname == e.to ? 'active' : '')} key={e.id} to={e.to} onClick={() => btn_nav_list(e)}>
                                                        <div className="image_nav" style={{ backgroundImage: `url(${(router.pathname == e.to ? e.active_img : e.img)})` }} > </div>
                                                        <span style={{ color: (router.pathname == e.to ? '#FF8800' : '#5E5E5E') }}>{translateWord(e.name)}</span>
                                                    </Link>
                                                )
                                            })}
                                        </>
                                }
                            </div>
                            : null
                    }
                    <div className="switch_account">

                        {user ?
                            <div className={'main_author'} onClick={() => setShowDropDown(true)}>

                                <div className="progress_percent" style={{
                                    backgroundImage: `conic-gradient(green  ${3.6 * user.progress}deg, ${appSettings && appSettings.lessons ? 'rgba(255,255,255,.5)' : 'transparent'} ${3.6 * user.progress}deg)`
                                }}>
                                    {
                                        notReadMessagesCount ?
                                            <div className="unread_message_count">

                                            </div>
                                            : null
                                    }
                                    <ImgAuthor
                                        className={'icons_navbar'}
                                        src={window._HOST_ + '/' + user.image}
                                        placeholder={default_user_img}
                                    />
                                </div>
                                <div className="parent_name_user_navbar">
                                    <h2 className="name_user_navbar">{user.name}</h2>
                                </div>
                            </div>

                            : null}

                        {showDropDown ?
                            <>
                                <div className="drop_down_navbar card_color">
                                    <div className="arrow_drop_down"></div>
                                    {
                                        localStorage.getItem('sub_users_disabled') ? null :
                                            <div className={'item_drop_down card_color'} onClick={isGuest ? () => {
                                                localStorage.setItem('showLogin', true)
                                                router.push('/auth')
                                            } : () => btn_drop_down_list(0)}>
                                                <img src={icon_subusers} alt="" />
                                                <span>{isGuest ? translateWord('Sign In', 'Sign In') : translateWord('switch account', 'Accounts')}</span>
                                            </div>
                                    }
                                    <div className="parent_settings_drop_down">
                                        {
                                            notReadMessagesCount ?
                                                <div className="unread_message_count_drop">

                                                </div>
                                                : null
                                        }
                                        <div className={'item_drop_down card_color'} onClick={() => btn_drop_down_list(1)}>

                                            <img src={icon_settings} alt="" />
                                            <span>{translateWord('Settings')}</span>
                                        </div>
                                    </div>


                                    {
                                        isGuest ? null :
                                            <div className={'item_drop_down card_color'} onClick={() => btn_drop_down_list(2)}>
                                                <img src={icon_log_out} alt="" />
                                                <span>{translateWord('logout', 'Log Out')}</span>
                                            </div>
                                    }
                                </div>
                                <div className="drop_down_parent" onClick={() => {
                                    setShowDropDown(false)
                                }}></div>
                            </>
                            : null}

                    </div>
                    {
                        hideMenu ?
                            null
                            :
                            <div className="parent_languages">
                                <div className={'select_languages'} onClick={() => setShowLangList(!showLangList)}>
                                    <div className={'item_languages'}>
                                        {activeLanguage ?
                                            <>
                                                {/* <img src={activeLanguage.icon} alt="" /> */}
                                                <span>{activeLanguage.name.slice(0, 3).toUpperCase()}</span>
                                            </>
                                            : null}
                                    </div>
                                </div>
                                {showLangList ?
                                    <div className="main_languages card_color">
                                        {languages.map((e, i) => {
                                            return (
                                                <div key={i} className={'item_languages card_color'} onClick={() => selectLanguage(e)}>
                                                    {/* <img src={e.icon} alt="" /> */}
                                                    <span>{e.name}</span>
                                                </div>
                                            )
                                        })}
                                    </div>
                                    : null}
                            </div>
                    }

                </div>
            </nav>
        </>
    )
}